import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateProductImage = async (placeId, productId, file) => {
  if (!placeId || !productId || !file) {
    console.log('NO PLACE ID');
    return;
  }
  let data = new FormData();
  data.append('file', file);

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/product/${productId}/update/image`,
    data,
  });
};